import type { TaskEditSheetTask } from "./TaskEditSheet";

export type TaskEditSheetState = {
  task: TaskEditSheetTask | null;
  areaPickerOpen: boolean;
};

export const EMPTY_TASK_EDIT_SHEET_STATE: TaskEditSheetState = {
  task: null,
  areaPickerOpen: false,
};

export function openTaskEditSheet(
  _state: TaskEditSheetState,
  task: TaskEditSheetTask,
): TaskEditSheetState {
  return { task, areaPickerOpen: false };
}

export function closeTaskEditSheet(): TaskEditSheetState {
  return EMPTY_TASK_EDIT_SHEET_STATE;
}

/**
 * List queries may remove the selected task after its date is cleared. The
 * sheet is hosted outside those rows, so a list refresh must not change its
 * selected task or visibility.
 */
export function preserveTaskEditSheetOnListRefresh(
  state: TaskEditSheetState,
): TaskEditSheetState {
  return state;
}
